var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { PureComponent } from 'react';
import { number, string, bool } from 'prop-types';
import { getRowsCount, getRowsWidth, htmlToText, textToHtml } from './util';
import { PRETTIFY_LAST_ROW_REGEXP, EPSILON, OVERFLOW_SIGN } from './const';

/**
 * @description
 * Обрезка многострочного текста/html под максимальное кол-во строк
 * с автоматическим доавлением '...' в конце
 */

var CuttedText = function (_PureComponent) {
    _inherits(CuttedText, _PureComponent);

    function CuttedText() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CuttedText);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CuttedText.__proto__ || Object.getPrototypeOf(CuttedText)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            text: _this.props.text,
            overflowed: false
        }, _this.setTextRef = function (ref) {
            return _this.textRef = ref;
        }, _this.setWrapperRef = function (ref) {
            return _this.wrapperRef = ref;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CuttedText, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setOverflowIfNeeded();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.text !== nextProps.text) {
                this.setState({
                    text: nextProps.text,
                    overflowed: false
                });
            }
        }
    }, {
        key: 'componentDidUpdated',
        value: function componentDidUpdated(oldProps) {
            if (this.props.text === oldProps.text) {
                this.setOverflowIfNeeded();
            }
        }

        /**
         * Превышает ли текущее количество строк максимально заданное
         * @return {Boolean}
         */

    }, {
        key: 'setOverflowIfNeeded',
        value: function setOverflowIfNeeded() {
            var rowsCount = this.props.rowsCount;


            if (getRowsCount(this.textRef) <= rowsCount) {
                return;
            }

            this.cut();

            return;
        }

        /**
         * Обрезка текста, если необходимо
         */

    }, {
        key: 'cut',
        value: function cut() {
            var _props = this.props,
                rowsCount = _props.rowsCount,
                isHtml = _props.html;

            var _wrapperRef$getBoundi = this.wrapperRef.getBoundingClientRect(),
                width = _wrapperRef$getBoundi.width;

            var meta = [];
            var rawText = htmlToText(this.textRef, meta);
            var first = 0;
            var last = rawText.length;
            var rowsWidth = void 0;
            var currentLastRowWidth = void 0;
            var isMaxRowsCount = void 0;
            var currentRowsCount = void 0;
            var mid = 0;
            var text = this.state.text;

            while (first < last) {
                // Деление на 2 без остатка
                mid = last + first >>> 1;

                var substring = rawText.substring(0, mid).replace(PRETTIFY_LAST_ROW_REGEXP, '');

                text = isHtml ? textToHtml(substring, meta, OVERFLOW_SIGN) : substring + OVERFLOW_SIGN;

                this.textRef.innerHTML = text;

                rowsWidth = getRowsWidth(this.textRef);
                currentLastRowWidth = rowsWidth[0];
                currentRowsCount = rowsWidth.length;
                isMaxRowsCount = currentRowsCount === rowsCount;

                // Если длина последней строки находится в пределах @see EPSILON
                // от максимально возможной то заканчиваем обрезку
                if (isMaxRowsCount && currentLastRowWidth <= width && currentLastRowWidth >= width - EPSILON) {
                    break;
                }

                // Обрезка текста выполняется с помощью алгоритма
                // бинарного поиска
                if (rowsCount < currentRowsCount || isMaxRowsCount && width < currentLastRowWidth) {
                    last = mid;
                } else {
                    first = mid + 1;
                }
            }

            if (currentRowsCount > rowsCount || rowsWidth[0] > width) {
                // Если после алгоритма двоичного поиска текст 
                // все еще не вписывается в максимальное количество
                // строк @see rowsCount, то уменьшаем длину текста
                // на единицу
                mid--;

                var _substring = rawText.substring(0, mid).replace(PRETTIFY_LAST_ROW_REGEXP, '');

                text = isHtml ? textToHtml(_substring, meta, OVERFLOW_SIGN) : _substring + OVERFLOW_SIGN;
            }

            this.setState({
                text: text,
                overflowed: true
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var text = this.state.text;
            var html = this.props.html;

            var dangerouslySetInnerHTML = html ? { __html: text } : null;

            return React.createElement(
                'div',
                { ref: this.setWrapperRef },
                React.createElement(
                    'span',
                    {
                        ref: this.setTextRef,
                        className: this.props.className,
                        dangerouslySetInnerHTML: dangerouslySetInnerHTML
                    },
                    html ? null : text
                )
            );
        }
    }, {
        key: 'overflowed',
        get: function get() {
            return this.state.overflowed;
        }
    }]);

    return CuttedText;
}(PureComponent);

CuttedText.defaultProps = {
    rowsCount: 1,
    html: false,
    text: ''
};
CuttedText.propTypes = {
    rowsCount: number.isRequired,
    text: string.isRequired,
    html: bool
};
export default CuttedText;